module.exports = __webpack_public_path__ + "img/all-inactive.36221f30.svg";